import environment from "./environment";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const config: { [key in (typeof environment)[number]]: string } = environment.reduce((ret: any, value) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ret[value] = (window as any)[`EXTERNAL__${value}__`];
    return ret;
}, {});

export default config;
